import PaginationButtonRow from '@shared/components/core/button/PaginationButtonRow';
import SubSectionRow from '@shared/components/core/headers/SubSectionRow';
import SearchField from '@shared/components/core/search/SearchField';
import { StickyFooterStretch } from '@shared/components/core/structure/CommonBodyLayoutStyles';
import LicenseExpiredBannerCard from '@shared/components/license/LicenseExpiredBannerCard';
import SplashLoader from '@shared/components/loading/SplashLoader';
import { extractRoleProperties } from '@shared/hooks/helpers/OrganizationalHelpers';
import useCurrentOrgDetailsFetching from '@shared/hooks/useCurrentOrgDetailsFetching';
import { useCurrentOrgInviteFetching } from '@shared/hooks/useCurrentOrgInviteFetching';
import useCurrentOrgInviteSearch from '@shared/hooks/useCurrentOrgInviteSearch';
import { useTranslation } from 'react-i18next';
import OrgNoAccessBanner from '../banners/OrgNoAccessBanner';
import InviteCardStack from './InviteCardStack';
import InviteEmptyBanner from './InviteEmptyBanner';

export default function InvitePageContent() {
    const { currentOrg, canInviteMembers, membership, isExpiredOrg, canManageBilling } = useCurrentOrgDetailsFetching();
    const { isLoading } = useCurrentOrgInviteFetching();
    const invitesSearch = useCurrentOrgInviteSearch();
    const { t } = useTranslation();
    const hasResults = (invitesSearch.results?.length ?? 0) > 0;

    if (!currentOrg) return null;
    if (isLoading) return <SplashLoader />;
    if (!canInviteMembers || !membership) return <OrgNoAccessBanner />;
    if (isExpiredOrg)
        return <LicenseExpiredBannerCard organizationId={currentOrg.id} canManageBilling={canManageBilling} />;

    return (
        <>
            <SearchField
                value={invitesSearch.searchQuery}
                onChange={(e) => invitesSearch.handleSearchQueryChange(e.target.value)}
                onClear={() => invitesSearch.handleSearchQueryChange('')}
            />
            {hasResults && <SubSectionRow title={t('common:results')} variant="small"></SubSectionRow>}
            {hasResults ? (
                invitesSearch.results?.map((invite, index) => (
                    <InviteCardStack key={index} invite={invite} myRole={membership} />
                ))
            ) : (
                <InviteEmptyBanner myRole={extractRoleProperties(membership)} organizationId={currentOrg.id} />
            )}
            <StickyFooterStretch $visuallyHide={!invitesSearch.results || invitesSearch.results.length == 0}>
                <PaginationButtonRow
                    onNext={invitesSearch.handleNext}
                    onPrevious={invitesSearch.handlePrevious}
                    disableNext={!invitesSearch.showNext}
                    disablePrevious={!invitesSearch.showPrevious}
                />
            </StickyFooterStretch>
        </>
    );
}
